<load-spinner
  [show]=this.showSpinner
></load-spinner>

<div class="row">
    <div class="col">
      <label class="mr-2" for="clientIdSelect">Configuring for Client: </label>
      <span style="width: 410px; display:inline-block">
        <ng-select 
          [virtualScroll]="true"
          [items]="sharedDataService.clientParties"
          bindLabel="partyName"
          [searchFn]="matchClientPartyRow"
          (change)="onSelectedClientChange()"
          [(ngModel)]="selectedClient">
          <ng-template ng-option-tmp let-item="item">
              {{item.clientParty.mailStop}} -- {{item.partyName}}
          </ng-template>
        </ng-select>
      </span>
    </div>
</div>

<ul class="nav mb-3 mt-3" [ngClass]="{'disabled': !selectedClient}">
  <li class="nav-item">
    <a class="nav-link pl-0" routerLink="custom-products/{{selectedClient ? selectedClient.clientParty.mailStop : '#'}}" routerLinkActive="active">Custom Products</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="backup-fields/{{selectedClient ? selectedClient.clientParty.mailStop : '#'}}" routerLinkActive="active">Backup Fields</a>
  </li>
</ul>

<div [ngClass]="{'disabled': !selectedClient}">
  <router-outlet></router-outlet>
</div>
